<div class="main">
    <div class="section">
        <div class="heading-wrapper">
            <div class="heading">Silence Detector</div>
        </div>
    </div>
    <div class="section" style="
      display: flex;
      gap: 55px;
      justify-content: space-around;
      align-items: center;
      height: auto;
    " [ngStyle]="{
      'flex-direction': uploadedOnce ? 'row' : 'column',
      'min-height.vh': uploadedOnce ? '20' : 'auto'
    }">
        <div>
            <app-inputs (showOutputComponent)="showOutput($event)"></app-inputs>
        </div>

        <div *ngIf="isOutputReady || uploadedOnce" style="display: flex; justify-content: center; align-items: center">
            <app-outputs [outputReady]="isOutputReady"></app-outputs>
        </div>
    </div>

    <div class="section" style="width: 84vw; min-height: 52vh; height: auto; padding: 0px" *ngIf="isOutputReady || uploadedOnce">
        <app-features-dashboard [isOutputReady]="isOutputReady"></app-features-dashboard>
    </div>
</div>